import styled from 'styled-components'
import ArrowRightSVG from '../../images/arrow_right.svg'



export const SectionWrapper = styled.div`

height: 100%;
width: 95%;
margin: 5px auto;
margin-bottom: 100px;
padding: 5vh 4vw 10vh;

`

export const KitDescWrapper = styled.div`
height: 100%;
max-height: 630px;
padding: 0 50px;
display: flex;
justify-content: center;
flex-direction: column;

@media screen and (max-width: 768px) {
    text-align: center;
    padding: 3vw;
}
`

export const KitTitle = styled.h2`
display: block;
width: fit-content;
letter-spacing: ${({ls}) => ls };
color: ${({color}) => (color==='') ? '#fff' : color};
background-color: ${({bg_color}) => (bg_color==='') ? 'inherit' : bg_color};
font-family: ${({font}) => (font==='') ? 'inherit' : font};
font-size: ${({font_size}) => (font_size==='') ? 'inherit' : font_size};
margin: 0;
line-height: 1.1;
font-weight: bold;


@media screen and (max-width: 768px) {
    margin: 0 auto;
    font-size: 24px;
}
`

export const KitDescText = styled.p`
color: ${({color}) => (color==='') ? '#fff' : color};
background-color: ${({bg_color}) => (bg_color==='') ? 'inherit' : bg_color};
font-family: ${({font}) => (font==='') ? 'inherit' : font};
font-size: ${({font_size}) => (font_size==='') ? 'inherit' : font_size};
margin: 5vh 0;
line-height: 1.1;

@media screen and (max-width: 768px) {
    font-size: 16px;
    margin: 2vh auto;
}

@media screen and (max-width: 480px) {
    font-size: 14px;
    margin: 2vh auto;
}
`

export const KitButton = styled.a`
display: flex;
align-items: center;
justify-content: center;
width: 19vw;
height: 10vh;
border: 2px solid ${({color}) => color};
color: #fff;
background-color: inherit;
font-family: ${({font}) => (font==='') ? 'inherit' : font};
font-size: ${({font_size}) => (font_size==='') ? 'inherit' : font_size};
text-align: center;
text-decoration: none;
cursor: pointer;
opacity: 0.9;

@media screen and (max-width: 768px) {
    margin: 0 auto;
    width: 30vw;
    height: 4vh;
    font-size: 15px;
    line-height: 3vh;
    padding: 0.27vh 0;
}

@media screen and (max-width: 480px) {
    font-size: 10px;
}

&:hover, &:active {
    text-decoration: none;
    color: white;
}

&:hover{
    background-color: ${({color}) => color};
    opacity: 1;
}

&:active{
    background-color: ${({color}) => color};
    opacity: 1.2;
}

`

export const KitImageWrapper = styled.div`
display: flex;
align-items: center;
justify-content: center;
`

export const Image = styled.img`
display: block;
margin: 0 auto;
width: 40vw;
`

export const ArrowRight = styled.div`
display: inline-block;
margin-left: 1.3vw;
background-color: inherit;
background-image: url('${ArrowRightSVG}'); /* The image used */
background-size: contain;
background-repeat: no-repeat; /* Do not repeat the image */
width: 16px;
height: 16px;
border-radius: 9px;

@media screen and (max-width: 768px) {
    margin-left: 1.6vw;
    width: 10px;
    height: 10px;
}

@media screen and (max-width: 480px) {
    width: 7px;
    height: 7px;
}


transition: all 0s linear;

`
